import {
  Directive,
  ElementRef,
  HostBinding,
  OnDestroy,
  ViewChild,
  input,
  linkedSignal,
  output
} from "@angular/core";
import { Subject } from "rxjs";
import { FormModelDirective } from "./form-model.directive";
import { KeyValue } from "@angular/common";

@Directive()
export class FormSelectComponentDirective extends FormModelDirective implements OnDestroy {

  @ViewChild('providerRef')
  provider!: ElementRef;

  @HostBinding('class.is-open')
  showOptionList: boolean = false;

  readonly searchFocus = output<boolean>();

  _options: KeyValue<string, string>[] = [];

  readonly required = input(undefined, {
    transform: (value: string | boolean) => value === true || value === ''
  })

  readonly placeholder = input<string>('Select an option');

  readonly options = input<KeyValue<string, string>[]>();

  readonly displayOptions = linkedSignal(() => {
    const result = this.options();

    if (result === undefined || result.length === 0) {
      return [];
    }

    if (!this.required() && !this._options.some(it => it.key === '')) {
      result.unshift({ key: '', value: this.placeholder() });
    }

    return result;
  })

  get selected(): KeyValue<string, string> | undefined {
    return this.displayOptions().find((el: KeyValue<string, string>) => el.key === this.value) || this.displayOptions()[0];
  }

  protected destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
